import React from 'react';
import { Link } from 'react-router-dom';

import s from './style.less';

class FindPlan extends React.Component {
  state = {
    plans: [],
    serached: false,
    reg: '',
    surname: '',
  };

  submit = async e => {
    try {
      e.preventDefault();
      const plans = await fetch('/provider/find-plan', {
        method: 'post',
        body: {
          reg: this.state.reg.replace(/\s/g, ''),
          surname: this.state.surname,
        },
      });

      this.setState({
        plans,
        serached: true,
      });
    } catch (err) {
      // Do nothing
    }
  };

  changeReg = e => {
    this.setState({
      reg: e.target.value,
    });
  };

  changeSurname = e => {
    this.setState({
      surname: e.target.value,
    });
  };

  render() {
    return (
      <div className={s.root}>
        <form className={s.form} onSubmit={this.submit}>
          <label>
            <span>Car registration</span>
            <input name="reg" onChange={this.changeReg} />
          </label>
          <label>
            <span>Surname</span>
            <input name="surname" onChange={this.changeSurname} />
          </label>
          <button className={s.btn}>GO</button>
        </form>
        {this.state.plans.length > 0 && (
          <div>
            <div className={s.table}>
              <b>Contract Number</b>
              <b>Registration</b>
              <b>Customer</b>
              <b />
            </div>
            <hr />
            {this.state.plans.map((x, key) => (
              <div key={key}>
                <hr />
                <div className={s.table}>
                  <div>{x.contractNumber}</div>
                  <div>{x.VRN}</div>
                  <div>
                    {x.Customer.firstName} {x.Customer.lastName}
                  </div>
                  <div>
                    <Link
                      to={`/provider/bookings/create/${x.id}`}
                      className={s.button}
                    >
                      BOOK
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        {this.state.serached &&
          this.state.plans.length === 0 && (
            <div className={s.center}>No plans found</div>
          )}
      </div>
    );
  }
}

export default FindPlan;
